<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-container(fluid)
        v-row
          v-col(cols="12" sm="6" md="4")
            BaseTextField(rules="required" v-model="form.name", :label="translations.label.name")
          v-col(cols="12" sm="6" md="4")
            BaseTextField(rules="required" v-model="form.code", :label="translations.label.code")
          v-col(cols="12" sm="6" md="4")
            BaseSelectField(rules="required", :items="accountManagerList" v-model="form.am", :label="translations.label.accountManager")
          v-col(cols="12" sm="6" md="4")
            BaseFloatField(v-model="form.ggr", :label="translations.label.ggr" min="0" max="100" decimals="2")
          v-col(cols="12" sm="6" md="4")
            BaseTextField(rules="required|host" v-model="form.icon", :label="translations.label.icon")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend Mode:
              v-row
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required" v-model="form.mode.fun", :label="translations.label.fun")
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required" v-model="form.mode.real", :label="translations.label.real")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend Platform:
              v-row
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required" v-model="form.platform.mobile", :label="translations.label.mobile")
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required" v-model="form.platform.desktop", :label="translations.label.desktop")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend Urls:
              v-row
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.launcher", :label="translations.label.urls.launcher")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.bonusAward", :label="translations.label.urls.bonusAward")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.bonusCancel", :label="translations.label.urls.bonusCancel")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.ping", :label="translations.label.urls.ping")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.roundDetails", :label="translations.label.urls.roundDetails")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.fixedLauncher", :label="translations.label.urls.fixedLauncher")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.baseUrl", :label="translations.label.urls.baseUrl")
                v-col.py-0(cols="12" sm="6" md="4")
                  BaseTextField(rules="host" v-model="form.urls.gameList", :label="translations.label.urls.gameList")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend Invoice:
              v-row
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required" v-model="form.invoice.name", :label="translations.label.invoice.name")
                v-col.py-0(cols="12" sm="6")
                  BaseTextAreaField(rules="required" v-model="form.invoice.address", :label="translations.label.invoice.address")
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required" v-model="form.invoice.vat", :label="translations.label.invoice.vat")
                v-col.py-0(cols="12" sm="6")
                  //- BaseFloatField(v-model="form.invoice.tax", :label="translations.label.invoice.tax", :required="true" min="0" max="100" decimals="2")
                  BaseTextField(rules="required|numeric|min_value:0" v-model="form.invoice.tax", :label="translations.label.invoice.tax")
                  //- BaseTextField(rules="required" v-model="form.invoice.tax", :label="translations.label.invoice.tax")
                v-col.py-0(cols="12" sm="6")
                  BasePhoneField(rules="required" v-model="form.invoice.phone", :label="translations.label.invoice.phone")
                v-col.py-0(cols="12" sm="6")
                  BaseTextField(rules="required|email" v-model="form.invoice.email", :label="translations.label.invoice.email")
        v-row
          v-col(cols="12")
            fieldset.fantasy__fieldset--basic
              legend {{ translations.label.config.title }}:
              v-row
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.rst", :label="translations.label.config.rst")
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.amb", :label="translations.label.config.amb")
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.rnc", :label="translations.label.config.rnc")
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.anr", :label="translations.label.config.anr")
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.aoc", :label="translations.label.config.aoc")
                v-col.py-0(cols="12" sm="6" md="4")
                  v-checkbox.mt-0(v-model="form.cfg.hfr", :label="translations.label.config.hfr")
        v-row(v-if="form.cfg.hfr")
          v-col(cols="12").py-4
            v-expansion-panels(accordion)
              v-expansion-panel
                v-expansion-panel-header
                  p.title.ma-0 {{ translations.label.customfields }}
                v-expansion-panel-content
                  v-divider.mb-4
                  v-switch(v-model="form.freerounds.multigame")
                      template(v-slot:label)
                        span(v-if="form.freerounds.multigame")
                          | {{ translations.label.selection }}: {{ translations.label.singleGame }} | 
                          strong {{ translations.label.multiGame }}
                        span(v-else)
                          | {{ translations.label.selection }}: 
                          strong {{ translations.label.singleGame }}
                          |  | {{ translations.label.multiGame }}
                  v-switch(v-model="form.freerounds.multiUser")
                      template(v-slot:label)
                        span(v-if="form.freerounds.multiUser")
                          | {{ translations.label.selection }}: {{ translations.label.singleUser }} | 
                          strong {{ translations.label.multiUser }}
                        span(v-else)
                          | {{ translations.label.selection }}: 
                          strong {{ translations.label.singleUser }}
                          |  | {{ translations.label.multiUser }}
                  v-divider.mb-4
                  BaseFieldsGenerator(:value="form.freerounds.fields" @input="updateFreeroundsFields")
        v-row
          v-col(cols="12").py-4
            v-expansion-panels(accordion)
              v-expansion-panel
                v-expansion-panel-header
                  p.title.ma-0 {{ translations.label.extrafields }}
                v-expansion-panel-content
                  v-divider.mb-4
                  BaseDynamicField(v-model="form.params" ref="dynamicField")
        v-row
          v-col(cols="12").py-4
            v-expansion-panels(accordion)
              v-expansion-panel
                v-expansion-panel-header
                  p.title.ma-0 {{ translations.label.extrafieldsHidden }}
                v-expansion-panel-content
                  v-divider.mb-4
                  BaseDynamicField(v-model="form.launcherParams" ref="dynamicFieldHidden")
        v-row
          v-col.pa-2.pa-md-6(cols="12")
            v-btn.float-right.big(:disabled="invalid"
              color="primary"
              type="submit"
              :loading="loadingCreate") {{ translations.buttons.create }}
</template>

<script>

  export default {
    name: "ProviderCreate",
    props:{
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      accountManagerList: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      form: {
        name: '',
        code: '',
        am: '',
        mode: {
          fun: null,
          real: null,
        },
        platform: {
          mobile: null,
          desktop: null,
        },
        ggr: null,
        urls: {
          launcher: '',
          bonusAward: '',
          bonusCancel: '',
          ping: '',
          roundDetails: '',
          fixedLauncher: '',
          baseUrl: '',
          gameList: '',
        },
        params: [],
        launcherParams: [],
        invoice: {
          name: '',
          address: '',
          vat: '',
          tax: '',
          phone: '',
          email: '',
        },
        icon: '',
        cfg: {
          rst: false,
          amb: false,
          rnc: false,
          anr: false,
          aoc: false,
          hfr: false,
        },
        freerounds: {
          multigame: false,
          multiUser: false,
          fields: [],
        },
        singleMultiGame: false,
      },
    }),
    computed: {
      loadingCreate() {
        return this.$store.state.statusCode.createProvider.loading;
      },
      stateCreate() {
        return this.$store.state.statusCode.createProvider.state;
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.clearFields();
          this.$refs.validator.reset();
        }
      },
      stateCreate: function(val){
        if (val == 200){
          this.$emit('successCreate');
        }
      },
    },
    created(){
      this.clearFields();
    },
    methods:{
      submitDataForm(){
        let formSend = {
          data: {
            name: this.form.name,
            code: this.form.code,
            am: this.form.am,
            mode: {
              fun: this.form.mode.fun,
              real: this.form.mode.real
            },
            platform: {
              desktop: this.form.platform.desktop,
              mobile: this.form.platform.mobile
            },
            urls: {
              launcher: this.form.urls.launcher,
              bonusAward: this.form.urls.bonusAward,
              bonusCancel: this.form.urls.bonusCancel,
              ping: this.form.urls.ping,
              roundDetails: this.form.urls.roundDetails,
              fixedLauncher: this.form.urls.fixedLauncher,
              baseUrl: this.form.urls.baseUrl,
              gameList: this.form.urls.gameList,
            },
            invoice: {
              name: this.form.invoice.name,
              address: this.form.invoice.address,
              vat: this.form.invoice.vat,
              tax: this.form.invoice.tax,
              phone: this.form.invoice.phone,
              email: this.form.invoice.email,
            },
            icon: this.form.icon,
            cfg: {
              rst: this.form.cfg.rst,
              amb: this.form.cfg.amb,
              rnc: this.form.cfg.rnc,
              anr: this.form.cfg.anr,
              aoc: this.form.cfg.aoc,
              hfr: this.form.cfg.hfr,
            },
          }
        };
        if(this.form.ggr != undefined && this.form.ggr != null && this.form.ggr != ''){
          formSend.data.ggr = parseFloat(this.form.ggr);
        }
        if (this.form.params.length){
          formSend.data.params = {};
          this.form.params.forEach((item) => {
            formSend.data.params[item.key] = item.value;
          });
        }
        if (this.form.cfg.hfr){
          formSend.data['fr'] = {};
          if (this.form.freerounds.fields.length){
            formSend.data.fr['f'] = this.form.freerounds.fields;
          }
          if (this.form.freerounds.multigame){
            formSend.data.fr['mg'] = this.form.freerounds.multigame;
          }
          if (this.form.freerounds.multiUser){
            formSend.data.fr['mu'] = this.form.freerounds.multiUser;
          }
        }
        if (this.form.launcherParams.length){
          formSend.data.launcherParams = {};
          this.form.launcherParams.forEach((item) => {
            formSend.data.launcherParams[item.key] = item.value;
          });
        }
        // console.log(formSend);
        this.$store.dispatch('createProvider', formSend);
      },
      updateFreeroundsFields(newFields){
        this.form.freerounds.fields = [...newFields];
      },
      clearFields(){
        this.form.name = '';
        this.form.code = '';
        this.form.am = '';
        this.form.ggr = null;
        this.form.mode.fun = null;
        this.form.mode.real = null;
        this.form.platform.mobile = null;
        this.form.platform.desktop = null;
        this.form.icon = '';
        this.form.urls.launcher = '';
        this.form.urls.bonusAward = '';
        this.form.urls.bonusCancel = '';
        this.form.urls.ping = '';
        this.form.urls.roundDetails = '';
        this.form.urls.fixedLauncher = '';
        this.form.urls.baseUrl = '';
        this.form.urls.gameList = '';
        this.form.invoice.name = '';
        this.form.invoice.address = '';
        this.form.invoice.vat = '';
        this.form.invoice.tax = '';
        this.form.invoice.phone = '';
        this.form.invoice.email = '';
        this.form.cfg.rst = false;
        this.form.cfg.amb = false;
        this.form.cfg.rnc = false;
        this.form.cfg.anr = false;
        this.form.cfg.aoc = false;
        this.form.cfg.hfr = false;
        this.form.multigame = false,
        this.form.params = [];
        this.form.launcherParams = [];
        this.form.freerounds.multigame = false;
        this.form.freerounds.multiUser = false;
        this.form.freerounds.fields = [];
        if(this.$refs != undefined && this.$refs.dynamicField != undefined){
          this.$refs.dynamicField.clear();
        }
        if(this.$refs != undefined && this.$refs.dynamicFieldHidden != undefined){
          this.$refs.dynamicFieldHidden.clear();
        }
      },
    }
  }
</script>

<style lang="sass">
</style>